<template lang="pug">
.py-2
  div
    .h6 Selecione a categoria da ocorrência
    .text-small Escolha a opção que melhor descreve a sua solicitação
  .mt-2.pt-2(v-if="loading")
    .loading.loading-lg
  .height-100(v-else, style="padding-bottom: 220px")
    .has-icon-left.mt-2
      input.form-input(placeholder="Buscar categoria", v-model="query")
      i.fa.fa-search.form-icon
    .scrollable.height-100(v-if="filteredList.length")
      grupos.mt-2.pt-2(:grupos="filteredList" :selected="form.categoria" @select="onSelectCategoria")
    .flex-centered.height-100(v-else)
      .empty
        .empty-icon
          i.fa.fa-search.fa-4x
        p.empty-title.h4 Ops!
        p.empty-subtitle Nenhuma categoria encontrada
        .empty-action
</template>

<script>
import ouvidoriaGrupos from "@/api/ouvidoriaGrupos";
import toastErrors from "@/lib/errors/toastErrors";
import Grupos from "./components/Grupos.vue";
import { transliterate } from "paliari-js-utils";

export default {
  vuex: {
    ocorrencias: {
      state: ["form"],
      mutations: ["setForm"],
    },
  },
  components: { Grupos },
  computed: {
    list() {
      const items = [];
      for (const grupo of this.grupos) {
        items.push({
          id: grupo.id,
          descricao: grupo.descricao,
          type: "grupo",
          icone: grupo.icone,
          palavras_chave: grupo.palavras_chave,
        });
        items.push({
          id: `${grupo.id}-categorias`,
          type: "categoria",
          categorias: grupo.categorias,
        });
      }

      return items;
    },
    filteredList() {
      let grupo_id = 0;
      const filtered = this.list.reduce((acc, item) => {
        if (item.type === "grupo") {
          grupo_id = Number(item.id);
          acc.push(item);
        }
        if (item.type === "categoria") {
          const categorias = item.categorias.filter((categoria) => {
            return (
              transliterate(
                `${categoria.descricao}${categoria.palavras_chave}`
              ).indexOf(transliterate(this.query)) > -1
            );
          });
          acc.push({
            id: `${grupo_id}-categorias`,
            type: "categoria",
            grupo_id,
            categorias,
          });
        }

        return acc;
      }, []);

      return filtered.filter((item) => {
        if (item.type === "categoria") return Boolean(item.categorias.length);

        const showGrupos = filtered.reduce((acc, i) => {
          if (i.type === "grupo") {
            const isNotEmpty = filtered
              .filter((listItem) => listItem.type === "categoria")
              .some(
                (cItem) =>
                  cItem.grupo_id === Number(i.id) && cItem.categorias.length > 0
              );
            if (isNotEmpty) acc.push(Number(i.id));
          }
          return acc;
        }, []);

        return showGrupos.includes(Number(item.id));
      });
    },
  },
  data() {
    return {
      query: "",
      grupos: [],
      loading: false,
    };
  },
  methods: {
    onSelectCategoria(categoria) {
      this.setForm({ ...this.form, categoria, categoria_id: categoria.id })
      this.$router.push({ name: 'app.ouvidoria.create.fotos' })
    }
  },
  async created() {
    try {
      this.loading = true;
      this.grupos = await ouvidoriaGrupos.list();
    } catch (e) {
      toastErrors(e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
